var _circle, _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBinanceSmartChainIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 24,
    cy: 24,
    r: 24,
    fill: "#F3BA2F"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.0639 21.5563L23.9935 15.6268L29.9258 21.5589L33.3759 18.1088L23.9935 8.72656L14.6141 18.106L18.0641 21.5561L18.0639 21.5563ZM8.72754 23.9926L12.1778 20.5418L15.6277 23.9918L12.1775 27.4421L8.72754 23.9926ZM18.0639 26.4291L23.9935 32.3583L29.9257 26.4263L33.3776 29.8746L33.3759 29.8764L23.9935 39.2585L14.6141 29.8791L14.6092 29.8742L18.0643 26.4288L18.0639 26.4291ZM32.3592 23.994L35.8094 20.5438L39.2594 23.9938L35.8093 27.444L32.3592 23.994Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M27.4922 23.9911H27.4936L23.993 20.4902L21.4055 23.077L21.1082 23.3744L20.4951 23.9876L20.4902 23.9924L20.4951 23.9974L23.993 27.4957L27.4939 23.9948L27.4956 23.9929L27.4924 23.9911",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBinanceSmartChainIcon);
export default __webpack_public_path__ + "static/media/binanceSmartChainIcon.5dd90c0d.svg";
export { ForwardRef as ReactComponent };